import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";
import { articles } from "@/mocks/articles";
import { faqs, siteInfo } from "@/mocks/siteData";
import Hero from "./components/Hero";
import FeaturedSection from "./components/FeaturedSection";
import CategoryGrid from "./components/CategoryGrid";
import ClipsSection from "./components/ClipsSection";
import GuideSection from "./components/GuideSection";
import ReviewsSection from "./components/ReviewsSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";

export default function Home() {
  usePageMeta({
    title: "网红翻车现场_直播事故_翻车视频回放与名场面截图 - 直播翻车观察局",
    description:
      "聚焦网红翻车现场，收录直播事故、翻车视频回放与关键截图。从带货失误到连线失控，名场面瞬间一网打尽，帮你快速定位吃瓜重点，看透每次翻车的真实经过。",
    keywords: "网红翻车,网红翻车现场,网红翻车直播事故,网红翻车视频回放,网红翻车截图,网红翻车名场面,网红翻车瞬间",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: siteInfo.name,
          url: "https://fanche-observer.example/",
          description: siteInfo.description,
          inLanguage: "zh-CN",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://fanche-observer.example/category?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@type": "Organization",
          name: siteInfo.name,
          email: siteInfo.email,
          description: siteInfo.description,
        },
        {
          "@type": "CollectionPage",
          name: "网红翻车现场合集",
          description: siteInfo.description,
          inLanguage: "zh-CN",
          mainEntity: {
            "@type": "ItemList",
            itemListElement: articles.slice(0, 6).map((item, index) => ({
              "@type": "ListItem",
              position: index + 1,
              name: item.title,
              url: `https://fanche-observer.example/article/${item.id}`,
            })),
          },
        },
        {
          "@type": "FAQPage",
          mainEntity: faqs.slice(0, 4).map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: { "@type": "Answer", text: item.a },
          })),
        },
      ],
    },
  });

  return (
    <SiteLayout>
      <Hero />
      <FeaturedSection />
      <CategoryGrid />
      <ClipsSection />
      <GuideSection />
      <ReviewsSection />
      <FaqSection />
      <SubscribeSection />
    </SiteLayout>
  );
}